'use client'

import { memo, useMemo } from 'react'

import { ProductTypes } from 'modules/products'
import { SeoListName } from 'shared/analytics'
import { isNotNilOrEmpty } from 'shared/utils/ramda'

import SpecialPromotionItem from './SpecialPromotionItem'

import styles from './SpecialPromotionRewardItem.module.scss'

const SPECIAL_PROMOTION_ITEMS_LIST_NAME =
  SeoListName.SPECIAL_PROMOTION_ITEMS_LIST_NAME

const SpecialPromotionRewardItem = memo(
  ({
    product,
    productGroup,
    seoButtonPlace
  }: {
    product: ProductTypes | null
    productGroup: ProductTypes[] | null
    seoButtonPlace: string
  }) => {
    const filteredProductGroup = useMemo(() => {
      return productGroup ?? []
    }, [productGroup])

    return (
      <div className={styles.wrapper}>
        <h3 className={styles.title}>
          {isNotNilOrEmpty(filteredProductGroup)
            ? 'Produkty do odebrania za wykorzystanie promocji:'
            : 'Produkt do odebrania za wykorzystanie promocji:'}
        </h3>
        {product && (
          <>
            <SpecialPromotionItem
              product={product}
              seoButtonPlace={seoButtonPlace}
              idxOnList={0}
              listName={SPECIAL_PROMOTION_ITEMS_LIST_NAME}
            />
            <div className={styles.tooltip}>
              Podana w tytule cena promocyjna produktu pojawi się po dodaniu
              produktu do koszyka, po wcześniejszym spełnieniu warunków
              promocji.
            </div>
          </>
        )}
        {isNotNilOrEmpty(filteredProductGroup) && (
          <>
            <div className={styles.itemsContainer}>
              {filteredProductGroup.map((productItem, idx) => (
                <SpecialPromotionItem
                  key={productItem.id}
                  product={productItem}
                  seoButtonPlace={seoButtonPlace}
                  idxOnList={idx}
                  listName={SPECIAL_PROMOTION_ITEMS_LIST_NAME}
                />
              ))}
            </div>

            <div className={styles.tooltip}>
              Podana w tytule cena promocyjna produktu pojawi się po dodaniu
              produktu do koszyka, po wcześniejszym spełnieniu warunków
              promocji.
            </div>
          </>
        )}
      </div>
    )
  }
)

export default SpecialPromotionRewardItem
